import PageContainer from '../../../../components/common/PageContainer';
import PMSCodeTable from './PMSCodeTable';

function PMSCodePage() {
  return (
    <>
      <PageContainer title='Servicing Databases' subTitle='PMS Code Master' showDate>
        PMS Code Master
        <PMSCodeTable />
      </PageContainer>
    </>
  );
}

export default PMSCodePage;
